// ============================================================================
// TEMPLATES DE LANÇAMENTO PF — CATÁLOGO HIERÁRQUICO DE 3 NÍVEIS (V2.0 — 11/06/2026)
// Fonte: agents/financeiro/MEMORY_BANK.md § TEMPLATES DE LANÇAMENTO PF
// Padrão: Grupo → Subcategoria → Item/Entidade (SUD: Nível 1 → Nível 2 → Nível 3)
// Fundamento: YNAB, Mobills, Organizze, Quicken — hierarquia com entidade-alvo
// ============================================================================

// ============================================================================
// MAPA CANÔNICO DE TEMPLATES (chave = ID do template)
// ============================================================================

export const TEMPLATE_MAP = {

  // =========================================================================
  // 🐶 PETS — Hierarquia por Pet → Subcategoria Funcional (10 templates)
  // =========================================================================

  // --- 🐕 Cauê (Cão Grande · Idoso) ---
  "T-C01": {
    group: "PETS",
    sub: "Alimentação Natural",
    descIn: "Retirada PJ Recta Scripta → Laskoski alim. Cauê",
    descOut: "Laskoski — Carne p/ Cauê (moela + lombo suíno)",
    account: "C6 PJ (Pix)",
    valorMin: 70,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Laskoski",
      nivel2: "Alimentação Natural",
      nivel3: "Cauê",
      vars: "Moela / Lombo Suíno",
    },
  },
  "T-C02": {
    group: "PETS",
    sub: "Banho / Tosa",
    descIn: "Retirada PJ Recta Scripta → Vet Hauer banho Cauê",
    descOut: "Veterinária Hauer — Banho e tosa Cauê (via Eliane)",
    account: "Cartão Eliane → reembolso",
    valorMin: 140,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Veterinária Hauer",
      nivel2: "Banho / Tosa",
      nivel3: "Cauê",
      vars: "",
    },
  },
  "T-C03": {
    group: "PETS",
    sub: "Remédio",
    descIn: "Retirada PJ Recta Scripta → Remédio Cauê parc. X/3",
    descOut: "Remédio — Cauê idoso (parcela X/3 R$ 118,67)",
    account: "Cartão Eliane → reembolso",
    valorMin: 118.67,    parcelado: true,
    recorrente: false,
    parcelaTotal: 3,
    suds: {
      nivel1: "Farmácia Vet",
      nivel2: "Remédio",
      nivel3: "Cauê",
      vars: "Parcela X/3",
    },
  },

  // --- 🐕 Marie (Cão Grande · Adulta) ---
  "T-M01": {
    group: "PETS",
    sub: "Alimentação Natural",
    descIn: "Retirada PJ Recta Scripta → Laskoski alim. Marie",
    descOut: "Laskoski — Carne p/ Marie (coração + fígado + moela + peito)",
    account: "C6 PJ (Pix)",
    valorMin: 157,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Laskoski",
      nivel2: "Alimentação Natural",
      nivel3: "Marie",
      vars: "Coração / Fígado / Moela / Peito",
    },
  },
  "T-M02": {
    group: "SAUDE",
    sub: "Farmácia",
    descIn: "Retirada PJ Recta Scripta → Tyrox 600mg Marie",
    descOut: "Casa do Produtor — Tyrox 600mg hipotireoidismo Marie",
    account: "C6 PJ (Pix)",
    valorMin: 190,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Casa do Produtor",
      nivel2: "Farmácia",
      nivel3: "Marie",
      vars: "Tyrox 600mg",
    },
  },

  // --- 🐕 Nina (Cão Médio · Adulta) ---
  "T-N01": {
    group: "PETS",
    sub: "Alimentação Natural",
    descIn: "Retirada PJ Recta Scripta → Tilápia Nina",
    descOut: "Tilápia — 10 pacotes filé p/ marmita fit Nina (via Eliane)",
    account: "Cartão Eliane → reembolso",
    valorMin: 189,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Fornecedor",
      nivel2: "Alimentação Natural",
      nivel3: "Nina",
      vars: "Tilápia 10 pacotes filé",
    },
  },

  // --- 🐕 Ayda/Dara/Mel (Cães · Ração Seca) ---
  "T-A01": {
    group: "PETS",
    sub: "Ração",
    descIn: "Retirada PJ Recta Scripta → Melo Pet Shop",
    descOut: "Melo Pet Shop — Ração Ayda/Dara/Mel + petiscos",
    account: "C6 PJ (Pix)",
    valorMin: 627,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Melo Pet Shop",
      nivel2: "Ração",
      nivel3: "Ayda/Dara/Mel",
      vars: "Ração N&D Ancestral + petiscos",
    },
  },
  "T-A02": {
    group: "PETS",
    sub: "Ração",
    descIn: "Retirada PJ Recta Scripta → Hiperzoo ração/petisco",
    descOut: "Hiperzoo — Ração N&D + petiscos (via Eliane)",
    account: "Cartão Eliane → reembolso",
    valorMin: 430,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Hiperzoo",
      nivel2: "Ração",
      nivel3: "Ayda/Dara/Mel",
      vars: "Ração N&D + petiscos",
    },
  },

  // --- 🐱 Frajola (Gato · Macho Adulto) ---
  "T-F01": {
    group: "PETS",
    sub: "Veterinário",
    descIn: "Retirada PJ Recta Scripta → Vet Frajola parc. X/6",
    descOut: "Veterinário — Frajola pós-mordida Marie (parcela X/6)",
    account: "Cartão Eliane → reembolso",
    valorMin: 250,    parcelado: true,
    recorrente: false,
    parcelaTotal: 6,
    suds: {
      nivel1: "Veterinário",
      nivel2: "Veterinário",
      nivel3: "Frajola",
      vars: "Parcela X/6",
    },
  },

  // --- 🌿 Compartilhado (Vegetais) ---
  "T-V01": {
    group: "PETS",
    sub: "Alimentação Natural",
    descIn: "Retirada PJ Recta Scripta → Qualifruti vegetais pets",
    descOut: "Qualifruti — Vegetais alimentação natural (chuchu, cenoura, cabotiá, batata doce, brócolis)",
    account: "C6 PJ (Pix)",
    valorMin: 115,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Qualifruti",
      nivel2: "Alimentação Natural",
      nivel3: "Compartilhado",
      vars: "Chuchu / Cenoura / Cabotiá / Batata Doce / Brócolis",
    },
  },

  // =========================================================================
  // 🍽️ ALIMENTAÇÃO — Hierarquia por Fornecedor → Subcategoria (7 templates)
  // =========================================================================

  "T-AL01": {
    group: "ALIMENTACAO",
    sub: "Feira",
    descIn: "Retirada PJ Recta Scripta → Qualifruti sacolão",
    descOut: "Qualifruti — Sacolão frutas/verduras",
    account: "C6 PJ (Pix)",
    valorMin: 60,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Qualifruti",
      nivel2: "Feira",
      nivel3: "",
      vars: "Frutas / Verduras",
    },
  },
  "T-AL02": {
    group: "ALIMENTACAO",
    sub: "Feira",
    descIn: "Retirada PJ Recta Scripta → Sacolão Boqueirão hortifrúti",
    descOut: "Sacolão Boqueirão — Hortifrúti",
    account: "C6 PJ (Pix)",
    valorMin: 110,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Sacolão Boqueirão",
      nivel2: "Feira",
      nivel3: "",
      vars: "",
    },
  },
  "T-AL03": {
    group: "ALIMENTACAO",
    sub: "Mercado",
    descIn: "Retirada PJ Recta Scripta → Super Muffato mercado",
    descOut: "Super Muffato — Mercado",
    account: "C6 PJ (Pix/Débito)",
    valorMin: 30,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Super Muffato",
      nivel2: "Mercado",
      nivel3: "",
      vars: "",
    },
  },
  "T-AL04": {
    group: "ALIMENTACAO",
    sub: "Mercado",
    descIn: "Retirada PJ Recta Scripta → Condor mercado",
    descOut: "Condor — Mercado (itens casa + alimentação)",
    account: "C6 PJ (Pix)",
    valorMin: 260,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Condor",
      nivel2: "Mercado",
      nivel3: "",
      vars: "Itens casa + alimentação",
    },
  },
  "T-AL05": {
    group: "ALIMENTACAO",
    sub: "Avulsos",
    descIn: "Retirada PJ Recta Scripta → PopHouse produtos",
    descOut: "PopHouse — Produtos alimentícios",
    account: "C6 PJ (Pix)",
    valorMin: 460,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "PopHouse",
      nivel2: "Avulsos",
      nivel3: "",
      vars: "",
    },
  },
  "T-AL06": {
    group: "ALIMENTACAO",
    sub: "Mercado",
    descIn: "Retirada PJ Recta Scripta → Festval mercado",
    descOut: "Festval — Mercado",
    account: "C6 PJ (Pix)",
    valorMin: 40,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Festval",
      nivel2: "Mercado",
      nivel3: "",
      vars: "",
    },
  },
  "T-AL07": {
    group: "ALIMENTACAO",
    sub: "Avulsos",
    descIn: "Retirada PJ Recta Scripta → Havan panificadora parc. X/10",
    descOut: "Havan — Panificadora (parcela X/10 R$ 69,90)",
    account: "Cartão Eliane → reembolso",
    valorMin: 69.90,    parcelado: true,
    recorrente: false,
    parcelaTotal: 10,
    suds: {
      nivel1: "Havan Panificadora",
      nivel2: "Avulsos",
      nivel3: "",
      vars: "Parcela X/10",
    },
  },

  // =========================================================================
  // 🎬 ESTILO DE VIDA — Hierarquia por Serviço → Subcategoria (10 templates)
  // =========================================================================

  "T-E01": {
    group: "ESTILO",
    sub: "Assinaturas Digitais",
    descIn: "Retirada PJ Recta Scripta → Google One assinatura",
    descOut: "Google One — Assinatura mensal storage pessoal + work",
    account: "C6 PJ (cartão débito)",
    valorMin: 96.99,    parcelado: false,
    recorrente: true,
    parcelaTotal: null,
    suds: {
      nivel1: "Google",
      nivel2: "Assinaturas Digitais",
      nivel3: "",
      vars: "Storage pessoal + work",
    },
  },
  "T-E02": {
    group: "ESTILO",
    sub: "Streaming",
    descIn: "Retirada PJ Recta Scripta → Netflix",
    descOut: "Netflix — Assinatura mensal (via Eliane)",
    account: "Cartão Eliane → reembolso",
    valorMin: 59.90,    parcelado: false,
    recorrente: true,
    parcelaTotal: null,
    suds: {
      nivel1: "Netflix",
      nivel2: "Streaming",
      nivel3: "",
      vars: "",
    },
  },
  "T-E03": {
    group: "ESTILO",
    sub: "Streaming",
    descIn: "Retirada PJ Recta Scripta → Disney+",
    descOut: "Disney+ — Assinatura mensal (via Eliane)",
    account: "Cartão Eliane → reembolso",
    valorMin: 46.90,    parcelado: false,
    recorrente: true,
    parcelaTotal: null,
    suds: {
      nivel1: "Disney+",
      nivel2: "Streaming",
      nivel3: "",
      vars: "",
    },
  },
  "T-E04": {
    group: "ESTILO",
    sub: "Streaming",
    descIn: "Retirada PJ Recta Scripta → Prime Video",
    descOut: "Prime Video — Assinatura mensal (via Eliane)",
    account: "Cartão Eliane → reembolso",
    valorMin: 19.90,    parcelado: false,
    recorrente: true,
    parcelaTotal: null,
    suds: {
      nivel1: "Prime Video",
      nivel2: "Streaming",
      nivel3: "",
      vars: "",
    },
  },
  "T-E05": {
    group: "ESTILO",
    sub: "Software & Ferramentas",
    descIn: "Retirada PJ Recta Scripta → ADSPOWER navegação",
    descOut: "ADSPOWER — Programa segurança navegação",
    account: "C6 PJ (Pix)",
    valorMin: 46.60,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "ADSPOWER",
      nivel2: "Software & Ferramentas",
      nivel3: "",
      vars: "",
    },
  },
  "T-E06": {
    group: "ESTILO",
    sub: "Assinaturas Digitais",
    descIn: "Retirada PJ Recta Scripta → Fernanda Giotti artigo",
    descOut: "Fernanda F. Giotti — Publicação artigo científico revista",
    account: "C6 PJ (Pix)",
    valorMin: 85.00,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Fernanda F. Giotti",
      nivel2: "Assinaturas Digitais",
      nivel3: "",
      vars: "Publicação artigo científico",
    },
  },
  "T-E07": {
    group: "ESTILO",
    sub: "Assinaturas Digitais",
    descIn: "Retirada PJ Recta Scripta → Registro.br domínio",
    descOut: "Registro.br — Domínio site pessoal",
    account: "C6 PJ (Pix)",
    valorMin: 40.00,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Registro.br",
      nivel2: "Assinaturas Digitais",
      nivel3: "",
      vars: "Domínio rodrigo.adv.br",
    },
  },
  "T-E08": {
    group: "ESTILO",
    sub: "Software & Ferramentas",
    descIn: "Retirada PJ Recta Scripta → C6 Garantido DeepSeek",
    descOut: "C6 Garantido — Recarga cartão pré-pago p/ DeepSeek dólar",
    account: "C6 PJ (Pix)",
    valorMin: 57.16,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "C6 Garantido",
      nivel2: "Software & Ferramentas",
      nivel3: "",
      vars: "DeepSeek dólar",
    },
  },
  "T-E09": {
    group: "ESTILO",
    sub: "Viagem",
    descIn: "Retirada PJ Recta Scripta → Reembolso viagem Eliane",
    descOut: "Viagem — Reembolso despesas viagem (via Eliane)",
    account: "Cartão Eliane → reembolso",
    valorMin: 316.49,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Viagem",
      nivel2: "Viagem",
      nivel3: "",
      vars: "Reembolso Eliane",
    },
  },
  "T-E10": {
    group: "ESTILO",
    sub: "Vestuário",
    descIn: "Retirada PJ Recta Scripta → Modas Karin roupas",
    descOut: "Modas Karin — Roupas (boleto nome da mãe pago por Eliane)",
    account: "Cartão Eliane → reembolso",
    valorMin: 66.00,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Modas Karin",
      nivel2: "Vestuário",
      nivel3: "",
      vars: "",
    },
  },

  // =========================================================================
  // ⚕️ SAÚDE — Medicamentos Recorrentes (10 templates)
  // =========================================================================

  "T-S01": {
    group: "SAUDE",
    sub: "Farmácia",
    descIn: "Retirada PJ Recta Scripta → Forxiga 10mg",
    descOut: "Farmácia — Forxiga 10mg (dapagliflozina)",
    account: "C6 PJ (Pix)",
    valorMin: 150,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Farmácia",
      nivel2: "Farmácia",
      nivel3: "Forxiga 10mg",
      vars: "Dapagliflozina",
    },
  },
  "T-S02": {
    group: "SAUDE",
    sub: "Farmácia",
    descIn: "Retirada PJ Recta Scripta → Glifage XR 500mg",
    descOut: "Farmácia — Glifage XR 500mg (metformina)",
    account: "C6 PJ (Pix)",
    valorMin: 40,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Farmácia",
      nivel2: "Farmácia",
      nivel3: "Glifage XR 500mg",
      vars: "Metformina",
    },
  },
  "T-S03": {
    group: "SAUDE",
    sub: "Farmácia",
    descIn: "Retirada PJ Recta Scripta → Rosucor 10mg",
    descOut: "Farmácia — Rosucor 10mg (rosuvastatina)",
    account: "C6 PJ (Pix)",
    valorMin: 60,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Farmácia",
      nivel2: "Farmácia",
      nivel3: "Rosucor 10mg",
      vars: "Rosuvastatina",
    },
  },
  "T-S04": {
    group: "SAUDE",
    sub: "Farmácia",
    descIn: "Retirada PJ Recta Scripta → Alopurinol 300mg",
    descOut: "Farmácia — Alopurinol 300mg",
    account: "C6 PJ (Pix)",
    valorMin: 30,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Farmácia",
      nivel2: "Farmácia",
      nivel3: "Alopurinol 300mg",
      vars: "",
    },
  },
  "T-S05": {
    group: "SAUDE",
    sub: "Farmácia",
    descIn: "Retirada PJ Recta Scripta → Donaren Retard 150mg",
    descOut: "Farmácia — Donaren Retard 150mg (trazodona)",
    account: "C6 PJ (Pix)",
    valorMin: 50,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Farmácia",
      nivel2: "Farmácia",
      nivel3: "Donaren Retard 150mg",
      vars: "Trazodona",
    },
  },
  "T-S06": {
    group: "SAUDE",
    sub: "Farmácia",
    descIn: "Retirada PJ Recta Scripta → Rivotril 2mg",
    descOut: "Farmácia — Rivotril 2mg (clonazepam)",
    account: "C6 PJ (Pix)",
    valorMin: 25,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Farmácia",
      nivel2: "Farmácia",
      nivel3: "Rivotril 2mg",
      vars: "Clonazepam",
    },
  },
  "T-S07": {
    group: "SAUDE",
    sub: "Farmácia",
    descIn: "Retirada PJ Recta Scripta → Selozok 50mg",
    descOut: "Farmácia — Selozok 50mg (metoprolol)",
    account: "C6 PJ (Pix)",
    valorMin: 35,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Farmácia",
      nivel2: "Farmácia",
      nivel3: "Selozok 50mg",
      vars: "Metoprolol",
    },
  },
  "T-S08": {
    group: "SAUDE",
    sub: "Farmácia",
    descIn: "Retirada PJ Recta Scripta → Prysma 3mg",
    descOut: "Farmácia — Prysma 3mg (risperidona)",
    account: "C6 PJ (Pix)",
    valorMin: 40,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Farmácia",
      nivel2: "Farmácia",
      nivel3: "Prysma 3mg",
      vars: "Risperidona",
    },
  },
  "T-S09": {
    group: "SAUDE",
    sub: "Farmácia",
    descIn: "Retirada PJ Recta Scripta → Cloridrato de Fexofenadina 120mg",
    descOut: "Farmácia — Cloridrato de Fexofenadina 120mg (antialérgico)",
    account: "C6 PJ (Pix)",
    valorMin: 35,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Farmácia",
      nivel2: "Farmácia",
      nivel3: "Cloridrato de Fexofenadina 120mg",
      vars: "Antialérgico",
    },
  },
  "T-S10": {
    group: "SAUDE",
    sub: "Farmácia",
    descIn: "Retirada PJ Recta Scripta → Remédio Avulso",
    descOut: "Farmácia — Remédio avulso (conforme receita)",
    account: "C6 PJ (Pix)",
    valorMin: 20,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Farmácia",
      nivel2: "Farmácia",
      nivel3: "Remédio Avulso",
      vars: "",
    },
  },

  // =========================================================================
  // 🏠 MORADIA — Hierarquia por Fornecedor → Subcategoria (3 templates)
  // =========================================================================

  "T-MR01": {
    group: "MORADIA",
    sub: "Energia Elétrica",
    descIn: "Retirada PJ Recta Scripta → Copel energia elétrica",
    descOut: "Copel — Energia elétrica residência",
    account: "C6 PJ (Pix)",
    valorMin: 350,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Copel",
      nivel2: "Energia Elétrica",
      nivel3: "",
      vars: "",
    },
  },
  "T-MR02": {
    group: "MORADIA",
    sub: "Diarista",
    descIn: "Retirada PJ Recta Scripta → diarista",
    descOut: "Diarista residencial",
    account: "C6 PJ (Pix)",
    valorMin: 1475,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Diarista",
      nivel2: "Diarista",
      nivel3: "",
      vars: "",
    },
  },
  "T-MR03": {
    group: "MORADIA",
    sub: "Reforma",
    descIn: "Retirada PJ Recta Scripta → AKI TEM bacias",
    descOut: "AKI TEM — Bacias cozinha/lavanderia (via Eliane)",
    account: "Cartão Eliane → reembolso",
    valorMin: 64.95,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "AKI TEM",
      nivel2: "Reforma",
      nivel3: "",
      vars: "",
    },
  },

  // =========================================================================
  // 💼 INVESTIMENTOS — Hierarquia por Compromisso → Subcategoria (1 template)
  // =========================================================================

  "T-FA01": {
    group: "INVESTIMENTOS",
    sub: "Acordo Herança Pai",
    descIn: "Retirada PJ Recta Scripta → Banco GM parc. X/48",
    descOut: "Banco GM — Parcela carro João Paulo (X/48 — acordo herança)",
    account: "C6 PJ (Pix)",
    valorMin: 1482.81,    parcelado: true,
    recorrente: false,
    parcelaTotal: 48,
    suds: {
      nivel1: "Banco GM",
      nivel2: "Acordo Herança Pai",
      nivel3: "João Paulo",
      vars: "Parcela X/48",
    },
  },

  // =========================================================================
  // 🏡 FAMÍLIA — Hierarquia por Compromisso → Subcategoria (1 template)
  // =========================================================================

  "T-FA02": {
    group: "FAMILIA",
    sub: "Reembolso Eliane",
    descIn: "Retirada PJ Recta Scripta → PIX Eliane consolidado",
    descOut: "PIX Familiar — Reembolso consolidado mês (streamings + pets + etc.)",
    account: "C6 PJ (Pix)",
    valorMin: 1500,    parcelado: false,
    recorrente: false,
    parcelaTotal: null,
    suds: {
      nivel1: "Familiar",
      nivel2: "Reembolso Eliane",
      nivel3: "",
      vars: "Streamings + pets + etc.",
    },
  },
};

// ============================================================================
// AGRUPAMENTO PARA RENDERIZAÇÃO DO <select> (optgroups)
// ============================================================================

export const TEMPLATE_GROUPS = [
  {
    label: "🐶 PETS",
    templates: [
      "T-C01", "T-C02", "T-C03",
      "T-M01", "T-M02",
      "T-N01",
      "T-A01", "T-A02",
      "T-F01",
      "T-V01",
    ],
  },
  {
    label: "🍽️ ALIMENTAÇÃO",
    templates: [
      "T-AL01", "T-AL02", "T-AL03", "T-AL04", "T-AL05", "T-AL06", "T-AL07",
    ],
  },
  {
    label: "🎬 ESTILO DE VIDA",
    templates: [
      "T-E01", "T-E02", "T-E03", "T-E04", "T-E05",
      "T-E06", "T-E07", "T-E08", "T-E09", "T-E10",
    ],
  },
  {
    label: "⚕️ SAÚDE",
    templates: ["T-M02", "T-S01", "T-S02", "T-S03", "T-S04", "T-S05", "T-S06", "T-S07", "T-S08", "T-S09", "T-S10"],
  },
  {
    label: "🏠 MORADIA",
    templates: ["T-MR01", "T-MR02", "T-MR03"],
  },
  {
    label: "💼 INVESTIMENTOS",
    templates: ["T-FA01"],
  },
  {
    label: "🏡 FAMÍLIA",
    templates: ["T-FA02"],
  },
];

// ============================================================================
// OPÇÕES DE CONTA (para dropdown)
// ============================================================================

export const ACCOUNT_OPTIONS = [
  "C6 PJ (Pix)",
  "C6 PJ (cartão débito)",
  "C6 PJ (Pix/Débito)",
  "Cartão Eliane → reembolso",
];

// ============================================================================
// CATÁLOGO DE PETS (para filtro rápido no modal)
// ============================================================================

export const PETS = [
  { id: "caue", nome: "🐕 Cauê", templates: ["T-C01", "T-C02", "T-C03"] },
  { id: "marie", nome: "🐕 Marie", templates: ["T-M01", "T-M02"] },
  { id: "nina", nome: "🐕 Nina", templates: ["T-N01"] },
  { id: "ayda", nome: "🐕 Ayda", templates: ["T-A01", "T-A02"] },
  { id: "dara", nome: "🐕 Dara", templates: ["T-A01", "T-A02"] },
  { id: "mel", nome: "🐕 Mel", templates: ["T-A01", "T-A02"] },
  { id: "frajola", nome: "🐱 Frajola", templates: ["T-F01"] },
  { id: "compartilhado", nome: "🌿 Compartilhado", templates: ["T-V01"] },
];

// ============================================================================
// LISTA PLANA DE IDs (para iteração)
// ============================================================================

export const ALL_TEMPLATE_IDS = Object.keys(TEMPLATE_MAP);

// ============================================================================
// TOTAL: 42 templates operacionais (10 PETS + 7 ALIMENTAÇÃO + 10 ESTILO + 10 SAÚDE + 3 MORADIA + 1 INVESTIMENTOS + 1 FAMÍLIA)
// Fonte: agents/financeiro/MEMORY_BANK.md § TEMPLATES DE LANÇAMENTO PF (11/06/2026)
// ============================================================================